export default "__VITE_ASSET__BPF8ZMbl__"